<template>
  <div class="barData" :class="{bgPicter:!isNodata}">
    <v-chart :options="barData" id="echart12" auto-resize @click="onEveryBar"></v-chart>
    <div
      class="no-chart-data"
      style="color:#D3D3D3;font-size:20px;"
      v-show="isNodata"
    >Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  let barColor = [
    "#5C89FF",
    "#7C6AF2",
    "#C95FF2",
    "#FF6383",
    "#FF9F40",
    "#FFCB48",
    "#31DC72",
    "#26DAD0",
    "#5CB3FF",
    "#8290FF",
    "#EF6BBB",
    "#FF7979",
    "#EBE300",
    "#26E7C7",
    "#13BAED"
  ];

  let result = [];
  for (let i = 0; i < barColor.length; i++) {
    result.push({
      type: "bar",
      barWidth: "50%", //调整双柱状图之间的间隔的
      label: {
        normal: {
          show: false,
          // position: "right"
          position: "insideRight"
        }
      },
      itemStyle: {
        normal: {
          color: barColor[i]
        }
      }
    });
  }
  return result;
};

export default {
  name: "EBar",
  // props: ["echartsData"],
  props: {
    echartsData: {},
    // 控制柱状图是否横向显示
    isHorizontal: {
      default: true
    },
    numShow: {
      type: Boolean,
      default: false
    },
    isNodata: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.setOptions();
    window.addEventListener("resize", () => {
      this.myChart12.resize();
    });
  },
  data() {
    return {
      barData: {},
      colorLength: 0,
      myChart12: ""
    };
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      let newResultData = this.$lodash.cloneDeep(this.echartsData);

      if (newResultData.length > 0) {
        newResultData[1].map((item, index) => {
          item = Object.assign(item, setOption()[index]);
        });
        this.barData = this.getOptions(newResultData, this.isHorizontal);
      }
      this.myChart12 = echarts.init(document.getElementById("echart12"));
    },
    getOptions(seriesData, Horizontal) {
      let xAxisVal = JSON.parse(JSON.stringify(seriesData[0]));
      let AseriesData = JSON.parse(JSON.stringify(seriesData[1]));
      this.colorLength = AseriesData.length;

      return {
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: "Save as picture"
            }
          },
          right: "15%"
        },
        // title: {
        //   show: this.echartsData[0].length === 0,
        //   textStyle: {
        //     color: 'LightGrey',
        //     fontSize: 20
        //   },
        //   text: 'Temporarily no data',
        //   left: 'center',
        //   top: 'center'
        // },
        title: {
          text: "Industry Vitality",
          show: false
        },
        tooltip: {
          trigger: "axis",
          // position: ['5%', '-30%'],
          confine:true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          // extraCssText: 'width:400px;height:auto;'
        },
        legend: {
          x: "right",
          y: " center",
          left: "88%",
          icon: "roundRect",
          orient: "vertical", // horizontal     vertical
          // itemWidth && itemHeight 同时设置更改大小
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10,
          fontFamily: "RCR",
          textStyle: {
            fontFamily: "RCR"
          },
          tooltip: {
            show: true,
            confine: true
          },
          formatter: function(name) {
            if (!name) return "";
            if (name.length > 5) {
              return name.slice(0,15) + "...";
            }else return name
          }
        },
        grid: {
          left: "1%",
          right: "20%",
          bottom: "3%",
          top: "2%",
          containLabel: true
        },
        xAxis: {
          type: Horizontal == true ? "value" : "category",
          // boundaryGap: false,
          boundaryGap: [0, 0.01],
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DFDFDF",
              width: 1
            }
          },
          axisLabel: {
            fontSize: 12,
            fontFamily: "RCR",
            textStyle: {
              color: "#00000",
              fontWeight: 1
            }
          },
          data: xAxisVal
        },
        yAxis: {
          type: Horizontal == true ? "category" : "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DFDFDF",
              width: 1
            }
          },
          splitLine: {
            show: false
          },
          // y axios 字体设置
          axisLabel: {
            fontSize: 12,
            fontFamily: "RCR",
            textStyle: {
              color: "#00000",
              fontWeight: 1
            }
          },
          data: xAxisVal
        },
        series: AseriesData
      };
    },
    //点击柱状图
    onEveryBar(params) {
      this.$emit("onEveryBar", params);
    }
  },
  watch: {
    echartsData() {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
  /* height: 100%; */
  /* height: 1000px; */
}
.barData {
  position: relative;
}
.barData .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -588%);
}
</style>
